import { HashTagPostInputModel } from "./PostInputModel"
import { HashTag } from "../../../models/tieup/HashTag"
import { httpPost } from "../../../libs/http/httpPost"

const endpointUrl = "/v1/hashtag"

/** タグ新規登録 */
export const callPostHashTags = async (
  model: HashTagPostInputModel,
): Promise<HashTag> => {
  return httpPost<HashTag>(endpointUrl, model)
}
